





import Vue from "vue";
import Component from "vue-class-component";
import * as echarts from 'echarts';
import {EChartsOption} from 'echarts'
import { Prop } from "vue-property-decorator";    

@Component
export default class Chart extends Vue{
    @Prop()
    option?: EChartsOption;

    mounted():void {
        const wrapper = this.$refs.wrapper as HTMLDivElement;
        let myChart = echarts.init(wrapper);
        if(this.option !== undefined) {
            myChart.setOption(this.option);
        }

        window.onresize = () => {
            myChart.resize();
        }
    }
}
